import React from 'react';
import styles from './OrdersPagination.module.css';

interface OrdersPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const OrdersPagination: React.FC<OrdersPaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className={styles.pagination}>
      <button className={styles.arrow} onClick={() => onPageChange(currentPage - 1)} disabled={currentPage <= 1}>
        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
      </button>
      <span className={styles.label}>Page {currentPage} of {totalPages}</span>
      <button className={styles.arrow} onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= totalPages}>
        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
      </button>
    </div>
  );
};
